export default __webpack_public_path__ + "static/Messaging-e2cd581ff54d58a38a221a656ab799c8.gif";